/**
 * @description renders the search personnel text field that's used by the Filter form
 */

import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

import withErrorBoundary from '@seccon/shared/ui/hocs/with-error-boundary';

const styles = {
  filterField: {
    backgroundColor: 'background.default'
  }
};

const SearchPersonnelTextField = () => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name='name'
      render={({ field: { onChange, value } }) => (
        <FormControl className='personnel'>
          <TextField
            label='Search Personnel'
            onChange={(evt) => onChange(evt.target.value)}
            size='small'
            sx={styles.filterField}
            value={value ?? ''}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        </FormControl>
      )}
    />
  );
};

export default withErrorBoundary(SearchPersonnelTextField);
